var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"hJcx_O-T7Yz3WPHYfH7c6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["posta-web@sentry"]={id:"hJcx_O-T7Yz3WPHYfH7c6"};
      